module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-body', [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "edit",
      "disabled": _vm.disable
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("新增商品")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.addForm.items,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "90%"
          },
          attrs: {
            "clearable": "",
            "remote": "",
            "placeholder": "请输入关键词",
            "filterable": "",
            "remote-method": _vm.getItems
          },
          on: {
            "change": function($event) {
              return _vm.selectItem(scope.row)
            }
          },
          model: {
            value: (scope.row.item),
            callback: function($$v) {
              _vm.$set(scope.row, "item", $$v)
            },
            expression: "scope.row.item"
          }
        }, _vm._l((_vm.items), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "供应商",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "90%"
          },
          attrs: {
            "clearable": "",
            "remote": "",
            "placeholder": "请输入关键词",
            "filterable": "",
            "remote-method": _vm.getVenders
          },
          model: {
            value: (scope.row.venderName),
            callback: function($$v) {
              _vm.$set(scope.row, "venderName", $$v)
            },
            expression: "scope.row.venderName"
          }
        }, _vm._l((_vm.venders), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位",
      "width": "75"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spec",
      "label": "规格",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unitQty",
      "label": "单位数量",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "manufacture",
      "label": "生产厂家"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "",
      "disabled": _vm.disable,
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "delete",
            "disabled": _vm.disable
          },
          on: {
            "click": function($event) {
              return _vm.removeItem(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "1.5rem 0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.disable) ? _c('el-button', {
    staticClass: "fa fa-save btn btn-info",
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30da3f6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AddItem.vue
// module id = 1759
// module chunks = 2